import * as React from 'react';

function SvgTimeRewindOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M4.056 13A9.002 9.002 0 0113 3a9 9 0 11-7.124 14.5M13 12V8.786M13 12l4 3.5" }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M2 11.5l2 2 2-2" })));
}

export default SvgTimeRewindOutline;
